"use strict";

exports.__esModule = true;
exports.StarContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var StarContainer = _styledComponents["default"].div(_templateObject());

exports.StarContainer = StarContainer;